import { Injectable } from '@angular/core';
import { ActiveState, EntityState, StoreConfig } from '@datorama/akita';
import { Y42EntityStore } from '@y42/state';
import { OrchestrationRunStoreModel } from './orchestration-run.model';

export interface OrchestrationRunState
  extends EntityState<OrchestrationRunStoreModel, OrchestrationRunStoreModel['run_id']>,
    ActiveState<OrchestrationRunStoreModel['run_id']> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'orchestration-run', idKey: 'run_id' })
export class OrchestrationRunStore extends Y42EntityStore<OrchestrationRunState> {
  constructor() {
    super({
      active: null,
    });
  }
}
